import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

/**
 * A custom Angular RouteReuseStrategy.
 * * By default, Angular reuses a component when navigating between routes that use the
 * same component class (e.g., navigating from `users/1` to `users/2`).
 * This strategy allows developers to override that behavior on a per-route basis.
 *
 * @usage
 * Add metadata to the route you want to prevent from being reused:
 * {
 * path: 'your-path/:id',
 * component: YourComponent,
 * data: { reuseRoute: false }
 * }
 */
@Injectable()
export class LumanaRouteReuseStrategy implements RouteReuseStrategy {

  shouldDetach(route: ActivatedRouteSnapshot): boolean { return false; }
  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {}
  shouldAttach(route: ActivatedRouteSnapshot): boolean { return false; }
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null { return null; }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future.routeConfig !== curr.routeConfig) {
      return false;
    }

    if (future.data['reuseRoute'] === false) {
      // Reuse only when both route params AND query params are identical
      const sameRouteParams = this.compareObjects(future.params, curr.params);
      const sameQueryParams = this.compareObjects(future.queryParams, curr.queryParams);
      return sameRouteParams && sameQueryParams;
    }

    return true;
  }

  private compareObjects(base: any, compare: any): boolean {
    const baseKeys = Object.keys(base);
    const compareKeys = Object.keys(compare);

    if (baseKeys.length !== compareKeys.length) {
      return false;
    }

    for (const key of baseKeys) {
      if (base[key] !== compare[key]) {
        return false;
      }
    }

    return true;
  }
}
